import React, { memo, useState } from 'react';
import moment from 'moment';
import { DateRangePicker } from 'react-dates';

import { screenBreakPoints } from 'Shared/constants/constants';
import { useWindowSize } from 'Shared/utils/hooks';

import './CustomDateRange.scss';

type Props = {
  customArrowIcon?: React.ReactNode;
  withPortal?: boolean;
  startRange: moment.Moment;
  endRange: moment.Moment;
  onRangeChange: Function;
};

function CustomDateRange({ customArrowIcon, startRange, withPortal, endRange, onRangeChange }: Props) {
  const windowSize = useWindowSize();
  const isDevice = windowSize.width <= screenBreakPoints.screenLg;
  const handleDateRangeChange = ({ startDate, endDate }) => onRangeChange({ startRange: startDate, endRange: endDate });

  const [focused, setFocused] = useState(null);
  const handleFocusChange = focusedInput => setFocused(focusedInput);
  return (
    <DateRangePicker
      customArrowIcon={customArrowIcon}
      numberOfMonths={isDevice ? 1 : 2}
      focusedInput={focused}
      startDate={startRange && moment(startRange)}
      endDate={endRange && moment(endRange)}
      startDateId="startRangeId"
      endDateId="endRangeId"
      withPortal={withPortal}
      onDatesChange={handleDateRangeChange}
      onFocusChange={handleFocusChange}
      isOutsideRange={() => false}
    />
  );
}

export default memo(CustomDateRange);
